import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CategoryList from "./tabItems/CategoryList";
import AddCategory from "./tabItems/AddCategory";
import { setCategory } from "../../store/slices/categorySlice";

export const categoryTabConfig = {
    LIST: "1",
    ADD: "2"
}

const CategoriesTab = () => {
    const [currentTab, setCurrentTab] = useState(categoryTabConfig.LIST);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(setCategory({}));
    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    } 

    const tabs = [
        {
          key: categoryTabConfig.LIST,
          label: 'Categories',
          children: <CategoryList onSwitchTab={onSwitchTab} />,
        },
        {
            key: categoryTabConfig.ADD,
            label: 'Add / Modify Product',
            children: <AddCategory onSwitchTab={onSwitchTab} tabProps={{}} />,
        }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== categoryTabConfig.ADD) {
            dispatch(setCategory({}));
        }
    };

    return (
        <div>
            <div className="text-2xl pb-3">Categories</div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default CategoriesTab;